export const isChromelessPathname = (pathname: string): boolean => pathname.includes('/chromeless')

// Are we in a chromeless context or path?
export const isChromelessPath = (): boolean => isChromelessPathname(location.pathname)
